export default __webpack_public_path__ + "static/media/11.9c176146.jpg";